import {Base, model, endpoint} from '@scoutgg/ftw/source/lib/model'

@model('EsportsLeague')
@endpoint('esports-info', {root: '/api'})
export class EsportsLeague extends Base {

}
